import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { addDays, format } from 'date-fns'
import {
  checkInputErrorMaxLength,
  checkInputErrorRequired,
  useDatePicker,
  useTextarea,
  useViewport
} from '@chilecompra/react-kit'
import { Textarea, Typography } from '@chilecompra/react-kit/components'
import { DatePicker, Divider, GridContainer, GridItem } from './QuoteBidSeller.styles'

/**
 * The Quote Bid Detail's component.
 */
const QuoteBidDetail = props => {
  const { setDescription, setEffectiveDate, disabled } = props
  const { size } = useViewport()
  const {
    error: detailsError,
    value: detailsValue,
    onChange: handleDetailsChange
  } = useTextarea({
    errorCallbacks: [checkInputErrorRequired(), checkInputErrorMaxLength(255)],
    changeCallback: updatedValue => setDescription(updatedValue)
  })
  const {
    error: effectiveDateError,
    value: effectiveDateValue,
    onChange: handleEffectiveDateChange
  } = useDatePicker({
    initialValue: addDays(new Date(), 30),
    changeCallback: updatedValue => setEffectiveDate(format(new Date(updatedValue), 'yyyy-MM-dd HH:mm:ss'))
  })
  const minEffectiveDate = useMemo(() => new Date(), [])

  return (
    <>
      <GridContainer padding="32px 0 0">
        <GridItem xs={12}>
          <Typography color="black1" fontSize="22px" fontWeight="bold" lineHeight="26px" variant="body1">
            Detalle de la cotización
          </Typography>
        </GridItem>
      </GridContainer>
      <GridContainer padding="20px 0 0">
        <GridItem xs={12}>
          <Divider />
        </GridItem>
      </GridContainer>
      <GridContainer padding="32px 0 0">
        <GridItem lg={3} md={12} padding={!size.isDownToTiny && '0 16px 0 0'} sm={12} xs={12}>
          <Typography color="black1" fontSize="14px" fontWeight="bold" lineHeight="18px" variant="body1">
            Detalle de la cotización
          </Typography>
          <Typography fontWeight="regular" color="black1" variant="body2">
            Ingresa información breve que describa y complemente tu cotización.
          </Typography>
        </GridItem>
        <GridItem lg={9} md={12} sm={12} xs={12}>
          <Textarea
            disabled={disabled}
            error={detailsError}
            label="Detalle cotización"
            maxCount={255}
            maxLength={255}
            value={detailsValue}
            onChange={handleDetailsChange}
          />
        </GridItem>
      </GridContainer>
      <GridContainer justifyContent="flex-end">
        <GridItem lg={3} md={12} sm={12} xs={12} />
        <GridItem lg={9} md={12} sm={12} xs={12}>
          <GridContainer>
            <GridItem lg={4} md={12} sm={12} xs={12}>
              <DatePicker
                disabled={disabled}
                error={effectiveDateError}
                label="Fecha de vigencia"
                minDate={minEffectiveDate}
                value={effectiveDateValue}
                onChange={handleEffectiveDateChange}
              />
            </GridItem>
            <GridItem lg={8} md={12} sm={12} xs={12} />
          </GridContainer>
        </GridItem>
      </GridContainer>
    </>
  )
}

QuoteBidDetail.defaultProps = {
  setDescription: null,
  setEffectiveDate: null,
  disabled: false
}

QuoteBidDetail.propTypes = {
  setDescription: PropTypes.func,
  setEffectiveDate: PropTypes.func,
  disabled: PropTypes.bool
}

export default QuoteBidDetail
